import {
  LOCALES
} from "@backmarket/http-api/src/standards/Locale";
import { toBcp47Locale } from "@backmarket/utils/string/toBcp47Locale";
export const getLocaleFromPath = (path) => {
  const supportedLocales = Object.values(LOCALES).map(toBcp47Locale);
  const pathWithoutQuery = path.split("?")[0] ?? path;
  const segments = pathWithoutQuery.split("/").filter(Boolean);
  const firstSegment = segments[0];
  return firstSegment && supportedLocales.includes(firstSegment) ? firstSegment : null;
};
